import type { Charity } from '../types';

let cache: Charity[] | undefined;

type CharityTree = {
  version: number;
  root: `0x${string}`;
  count: number;
  proofs: Record<string, `0x${string}`[]>;
};

export async function loadCharities(): Promise<Charity[]> {
  if (cache) return cache;
  const [directoryResponse, treeResponse] = await Promise.all([
    fetch('/charities.json'),
    fetch('/charity-tree.json'),
  ]);
  if (!directoryResponse.ok || !treeResponse.ok) {
    throw new Error('The verified charity directory and its onchain proofs could not be loaded.');
  }
  const data = (await directoryResponse.json()) as Omit<Charity, 'proof'>[];
  const tree = (await treeResponse.json()) as CharityTree;
  if (tree.version !== 1 || !/^0x[a-fA-F0-9]{64}$/.test(tree.root)) {
    throw new Error('The charity proof manifest is invalid.');
  }
  cache = data.flatMap((item) => {
    if (!/^0x[a-fA-F0-9]{64}$/.test(item.c)) return [];
    const proof = tree.proofs[item.c.toLowerCase()];
    return proof ? [{ ...item, proof }] : [];
  });
  if (cache.length !== tree.count) throw new Error('The charity directory does not match its proof manifest.');
  return cache;
}

export function findCharity(items: Charity[], configId: string) {
  return items.find((item) => item.c.toLowerCase() === configId.toLowerCase());
}
